"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _HBTableColumnHeader = _interopRequireDefault(require("./HBTableColumnHeader"));
var _HBTable = require("./HBTable.styles");
var _HBTableHorizontalShadowSyncScrollContainer = _interopRequireDefault(require("./HBTableHorizontalShadowSyncScrollContainer"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function HBTableColumnHeaders(_ref) {
  var table = _ref.table,
    tableBodyEl = _ref.tableBodyEl;
  var tdEls = useGetFirstRowTdEls(tableBodyEl);
  return /*#__PURE__*/_react["default"].createElement(_HBTableHorizontalShadowSyncScrollContainer["default"], {
    table: table
  }, /*#__PURE__*/_react["default"].createElement(_HBTable.Table, null, /*#__PURE__*/_react["default"].createElement(THead, null, /*#__PURE__*/_react["default"].createElement("tr", null, table.getAllColumns().map(function (column) {
    return /*#__PURE__*/_react["default"].createElement(_HBTableColumnHeader["default"], {
      table: table,
      key: column.id,
      column: column,
      tdEl: tdEls[column.getIndex()]
    });
  })))));
}
var _default = exports["default"] = HBTableColumnHeaders;
function useGetFirstRowTdEls(tableBodyEl) {
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    firstRowTdEls = _useState2[0],
    setFirstRowTdEls = _useState2[1];
  (0, _react.useEffect)(function () {
    if (!tableBodyEl) {
      return;
    }
    function getFirstRowTdEls() {
      var _tableBodyEl$querySel;
      var _firstRowTdEls = (_tableBodyEl$querySel = tableBodyEl.querySelector('tr')) === null || _tableBodyEl$querySel === void 0 ? void 0 : _tableBodyEl$querySel.getElementsByTagName('td');
      if (_firstRowTdEls) {
        setFirstRowTdEls((0, _toConsumableArray2["default"])(_firstRowTdEls));
      }
    }
    getFirstRowTdEls();
    var observer = new MutationObserver(getFirstRowTdEls);
    observer.observe(tableBodyEl, {
      subtree: true,
      childList: true,
      attributes: true
    });
    return function () {
      return observer.disconnect();
    };
  }, [tableBodyEl]);
  return firstRowTdEls;
}

// -------------------------- Styles -------------------------- //

var THead = _styledComponents["default"].thead.withConfig({
  displayName: "HBTableColumnHeaders__THead",
  componentId: "sc-1myooxm-0"
})(["table-layout:fixed;background-color:", ";"], _colors["default"].neutral100);
//# sourceMappingURL=HBTableColumnHeaders.js.map